import { ButtonIcon } from '@statsbomb/kitbag-components';
import { useTranslation } from 'react-i18next';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useUpdateQueryString } from '@/hooks/useUpdateQueryString';
import { noop } from '@/utils/noop';

export const CloseCardHeaderButton = ({
  navigationPath,
  paramsToDelete,
  onClick = noop,
}: {
  navigationPath: string;
  paramsToDelete?: string[];
  onClick?: () => void;
}) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const updateQueryString = useUpdateQueryString(searchParams);
  const { t } = useTranslation('general');
  const btnLabel = t('close');

  return (
    <ButtonIcon
      variant="ghost"
      onClick={() => {
        onClick();

        const newQueryString = updateQueryString([], paramsToDelete);
        navigate(`${navigationPath}?${newQueryString}`);
      }}
      icon="Close"
      title={btnLabel}
    >
      {btnLabel}
    </ButtonIcon>
  );
};
